function Controller($scope, $state, $filter, Administrator, PageHeading, AdministratorComponent, Toast) {
	'ngInject';

	const vm = this;
	vm.editAdministrator = editAdministrator;
	vm.getPaginationInfo = AdministratorComponent.getPaginationInfo;
	vm.administrator = {};

	activate();

	function activate() {
		vm.administratorId = Administrator.id;
		vm.administrator.profile = Administrator.profile;
		vm.administrator.email = Administrator.email;

		const heading = $filter('translate')('HEADING.EDITING_ADMINISTRATOR');
		const title = `BTMS | ${$filter('translate')('HEADING.EDITING_ADMINISTRATOR')}`;

		PageHeading.setPageHeading(heading, title);
	}

	function editAdministrator(params) {
		if ($scope.editAdministrator.$error.required || $scope.editAdministrator.email.$error.email) {
			Toast.error($filter('translate')('ERRORS.GENERAL'));

			return false;
		}

		AdministratorComponent.updateAdministrator(Administrator.id, params)
			.then(function(res) {
				if (res.data.errors) {
					Toast.responseError(res.data.errors);
				} else {
					Toast.success($filter('translate')('SUCCESS.UPDATE_ADMINISTRATOR'));
					$state.go('app.private.administrators.list', {'page': vm.getPaginationInfo().page});
				}
			});
	}
}

export default Controller;



/** WEBPACK FOOTER **
 ** ./client/private/administrators/edit/edit.controller.js
 **/